<template>
  <a-spin :spinning="spinning" tip="加载中...">
    <div class="top-title" @click="lastStep"><a-icon type="left" /> 维保详情</div>
    <div class="card-value-class">
      <a-row :gutter="[0, 15]">
        <a-col :span="24">
          <div class="all-card">
            <a-card :bordered="false">
              <div class="title-div-class">
                <span v-if="modalForm.type == 1">半月保</span>
                <span v-if="modalForm.type == 2">季度保</span>
                <span v-if="modalForm.type == 3">半年保</span>
                <span v-if="modalForm.type == 4">年度保</span>
              </div>
              <a-col :span="24">
                <a-divider />
              </a-col>
              <div class="m-list">
                <div class="m-list-col">
                  <a-row :gutter="[0, 10]">
                    <a-col :span="24">
                      <div class="m-list-con" v-if="modalForm.helperName">
                        <div class="div1">维保人员&协同人员</div>
                        <div class="div2">
                          {{ modalForm.maintainerName }}、{{modalForm.helperName}}
                        </div>
                      </div>
                      <div class="m-list-con" v-else>
                        <div class="div1">维保人员</div>
                        <div class="div2">
                          {{ modalForm.maintainerName }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">维保单位</div>
                        <div class="div2">
                          {{ modalForm.maintainerOrgName }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">开始时间</div>
                        <div class="div2">
                          {{ modalForm.beginTime ? formatDate(modalForm.beginTime) : '' }}
                        </div>
                      </div>
                    </a-col>
                    <a-col :span="24">
                      <div class="m-list-con">
                        <div class="div1">结束时间</div>
                        <div class="div2">
                          {{ modalForm.endTime ? formatDate(modalForm.endTime) : '' }}
                        </div>
                      </div>
                      </a-col>
                      <a-col :span="24">
                        <div class="m-list-con">
                          <div class="div1">维保时长</div>
                          <div class="div2" v-if="modalForm.beginTime && modalForm.endTime">
                            {{ twoTimeInterval(modalForm.beginTime, modalForm.endTime) }}
                          </div>
                        </div>
                      </a-col>
                  </a-row>
                </div>
              </div>
            </a-card>
          </div>
        </a-col>
        <div class="titleClass">
          <span class="text-title-class"/> 维保项目
        </div>
        <a-col :span="24">
          <div class="all-card">
            <a-card :bordered="false">
              <a-list size="small" item-layout="horizontal" :data-source="modalForm.items">
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <a-list-item-meta
                    :description="item.standard"
                  >
                   <div slot="title" class="project-title">{{ item.content }}</div>
                  </a-list-item-meta>
                  <a-icon type="check-circle" :style="{ fontSize: '18px',color: 'green' }" />
                </a-list-item>
              </a-list>
            </a-card>
          </div>
        </a-col>
      </a-row>
    </div>
  </a-spin>
</template>

<script>
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      mainId:null,
      modalForm: {},
      spinning:false,
    };
  },
  watch: {
    '$route.query': {
      immediate: true,
      handler(newQuery) {
        // 这里处理 query 参数变化的逻辑
        this.mainId = newQuery.id
      }
    }
  },
  created() {
    this.mainId = this.$route.query.id
    this.getMaintainDetail()
  },
  methods: {
    getMaintainDetail(){
      this.spinning = true
      let params = {
        id: this.mainId
      }
      axios.get(site.apiHost + "/elevator-public/maint-detail/get-by-id", { params }).then(res => {
        if (res.data.errorCode == 0) {
          this.modalForm = res.data.data
        }
      }).catch(error => {}).finally(()=>{
        this.spinning = false
      })
    },
    lastStep(){
      this.$router.back(-1); // 后退到上一页
    },
    addressOrNumm(value){
      if (value) {
        return value
      } else {
        return ''
      }
    },
    // 计算时间差
    twoTimeInterval(startTime, endTime) {
      let runTime = parseInt(endTime - startTime);
      let minute = Math.round(runTime / 1000 / 60);
      return minute + '分钟';
    },
    // 时间戳转换
    formatDate(timeStamp) {
      let time = new Date(Number(timeStamp)),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      return y + '-' + this.addZero(m) + '-' + this.addZero(d) + ' ' + this.addZero(h) + ':' + this
        .addZero(mm) + ':' + this.addZero(s);
    },
    formatDate2(timeStamp) {
      let time = new Date(Number(timeStamp)),
        y = time.getFullYear(),
        m = time.getMonth() + 1,
        d = time.getDate(),
        h = time.getHours(),
        mm = time.getMinutes(),
        s = time.getSeconds();
      return y + '-' + this.addZero(m) + '-' + this.addZero(d);
    },
    addZero(num) {
      if (num < 10) return '0' + num;
      return num;
    },
  }
};
</script>

<style lang="less" scoped>
.m-list {
  width: 100%;
  height: auto;
}

.m-list-col {
  width: 100%;
}

.m-list-con {
  color: #333333;
  display: flex;
}

.div1 {
  font-size: 14px;
  font-weight: 400;
  flex-shrink: 0;
  color: #999999;
}
.div2 {
  font-size: 14px;
  font-weight: 400;
  flex: 1;
  padding-left:15px;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.elev-title {
  font-size: 16px;
  color: #000000;
  font-weight: bold;
}

.card-div {
  font-weight: bold;
  font-family: PingFangSC-Regular, PingFang SC;
}
/deep/ .ant-card {
  border-radius: 10px;
}
/deep/ .ant-card-body {
  padding: 15px;
  zoom: 1;
}
/deep/ .ant-divider-horizontal {
  display: block;
  clear: both;
  width: 100%;
  min-width: 100%;
  height: 1px;
  margin: 0px 0;
}
.title-div {
  font-size: 16px;
  font-family: PingFangSC, PingFang SC;
  color: #333333;
  padding-bottom: 10px;
}
.all-card{
  background: #FFFFFF;
  border-radius: 10px;
}
.top-title{
  background: #ff4d4f;
  width: 100%;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #ffffff;
  padding: 0 10px;
  margin-bottom: 15px;
  cursor: pointer;
}
.card-value-class{
  margin: 0px 15px;
}
.cardBorder {
  font-size: 14px;
  padding-left: 10px;
}
.cardBorder2 {
  font-size: 14px;
  padding-left: 10px;
}
.cardBorder::after {
  content: "";
  position: absolute;
  right: 15px;
  top: 2px;
  width: 1px;
  background-color: #dddddd;
  height: 90%;
}
.value-num{
  font-size: 30px;
  font-weight: bold;
}
.title-div-class{
  font-size: 18px;
  font-weight: bold;
  color: #333333;
  border: none;
  padding-bottom: 5px;
}
.contil1 img {
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius: 10px;
}

/deep/ .ant-carousel {
  margin: 0px !important;

  .slick-slide {
    text-align: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
}

/deep/ .ant-carousel {
  .custom-slick-arrow {
    width: 40px;
    height: 40px;
    font-size: 20px;
    text-align: center;
    line-height: 40px;
    border-radius: 40px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.2);
    opacity: 1;
    margin: 0;
    margin-top: -20px;
  }

  .custom-slick-arrow:before {
    display: none;
  }

  .custom-slick-arrow:hover {
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .slick-slide h3 {
    color: #fff;
  }

  .slick-dots-bottom {
    bottom: 2rem;

    li button {
      width: 14px;
      height: 14px;
      border-radius: 20px;
    }
  }
}

.titleClass {
  margin: 5px 0px 0px 5px;
  font-size: 14px;
  font-weight: bold;
}

.text-title-class {
  background-color: #ff4d4f;
  width: 4px;
  height: 15px;
  float: left;
  margin-top: 10px;
  margin-right: 6px;
  transform: translateY(-50%);
  content: '';
}
.project-title{
  color: #333333;
}

</style>



// WEBPACK FOOTER //
// src/components/maintainDetail.vue